import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

const noticeItems = [
  "线索须真实、可核实，避免凭猜测与传闻提交；",
  "请勿提交与公共利益无关的他人隐私信息；",
  "若有照片、录音、合同等材料，可在提交时一并说明来源；",
  "提交后请保持预留联系方式畅通，便于后续对接。",
];

export default function Faq() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://guilinzsw.cn/" },
        { "@type": "ListItem", position: 2, name: "常见问题", item: "https://guilinzsw.cn/faq" },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="常见问题 | 爆料51 线索提交与来源保护说明"
        description="了解爆料51 的征集规则、来源保护机制、悬赏评定标准与反馈时长，以及哪些内容不会被采纳，帮助你更高效地提供线索。"
        keywords="爆料51常见问题,线索提交须知,来源保护,悬赏标准"
        path="/faq"
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="常见问题"
        title="关于提供线索，你想知道的都在这里"
        description="从提交方式到来源保护，从悬赏评定到反馈周期，我们把最常被问到的问题集中整理，方便你在提交前先了解清楚。"
        crumbs={[{ label: "常见问题" }]}
      />

      <section className="w-full bg-background-100 py-12 md:py-16">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-8">
            <Reveal>
              <FaqAccordion items={faqs} defaultOpenId={faqs[0]?.id} />
            </Reveal>
          </div>

          <aside className="lg:col-span-4">
            <Reveal delay={100}>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-error-warning-line text-primary-600" />
                  提交前须知
                </h2>
                <ul className="mt-4 flex flex-col gap-3">
                  {noticeItems.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                      <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={160}>
              <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-5">
                <h2 className="font-heading text-base font-bold text-foreground-950">还有疑问？</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  如果在提交过程中遇到问题，可以先把线索发到征集邮箱，我们会协助你整理信息。
                </p>
                <p className="mt-3 flex items-center gap-2 text-sm text-foreground-800">
                  <i className="ri-mail-line text-primary-600" />
                  tips@baoliao51.com
                </p>
                <Link
                  to="/submit"
                  className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-megaphone-line" />
                  前往提交线索
                </Link>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </>
  );
}